'use strict'

$id = $('body').attr('id')
$class = $('body').attr('class')
smoothScroll = (target, duration)->
  if duration is null
    duration = 1000

  scrollTo = $(target).offset().top - $('.l-header').height()

  $(
    if (navigator.userAgent.indexOf('Opera') isnt -1)
    then (
      if document.compatMode is 'BackCompat'
      then 'body'
      else 'html'
    )
    else 'html,body'
  ).animate({
    scrollTop: scrollTo
  },{
    easing:'easeInOutCirc',
    duration: duration
  })

$('a[href^="#"]'+'a[href!="#"]').not('.js-tab-item').on('click.smoothScroll'
  (e)->
    e.preventDefault()
    smoothScroll($(this).attr('href'))
)

$(window).on('load',
  ()->
    hash = location.hash

    if window.matchMedia('(max-width:750px)').matches
      # SPの処理
      currentScrollPos = 0
      firstView = 'SP'

      $('.l-header__hum').on('click.sp',
        (e)->
          e.stopPropagation()
          if $('body').hasClass('is-fix')
            $('body').removeClass('is-fix').removeAttr('style')
            $('html, body').scrollTop(currentScrollPos)

            $('.l-header__menu').removeClass('is-open')
            $('.l-header__hum').removeClass('is-open')
          else
            currentScrollPos = $(window).scrollTop()

            $('body').addClass('is-fix').css({
              top: currentScrollPos * -1
            })

            $('.l-header__menu').addClass('is-open')
            $('.l-header__hum').addClass('is-open')
      )

      $('.l-container').on('click.sp',
        (e)->
          if $('body').hasClass('is-fix')
            e.stopPropagation()
            $('.l-header__hum').triggerHandler('click.sp')
      )

    if location.href.indexOf('#') isnt -1
      $('a[href="#'+location.href.split('#')[1]+'"]').triggerHandler('click.smoothScroll')
)


$('.js-accordion__title, .navi__list__item' ).on('click',
  ()->
    $parent = $root = $(this).closest('.js-accordion')
    $parent.removeClass('is-close')
    $parent.toggleClass('is-open')
    parentContentsHeight = rootContentsHeight = $parent.find('> .js-accordion__contents > .js-accordion__contents__inner').outerHeight()

    if $parent.hasClass('is-open')
      $parent.find('> .js-accordion__contents').css({
        'height': parentContentsHeight
        'maxHeight': parentContentsHeight
      })
    else
      $parent.find('> .js-accordion__contents').removeAttr('style')

    if $parent.hasClass('is-open-all')
      $parent.toggleClass('is-open-all')
      $parent.addClass('is-close-all')
    else if $parent.hasClass('is-close-all')
      $parent.toggleClass('is-close-all')
      $parent.addClass('is-open-all')

    if $parent.hasClass('js-subaccordion')
      $root = $parent.parents('.js-accordion')
      rootContentsHeight = $root.find('> .js-accordion__contents > .js-accordion__contents__inner').outerHeight()

      if $root.hasClass('is-open') and $parent.hasClass('is-open')
        $root.addClass('is-open-all')
      else
        $root.removeClass('is-open-all')

      if $root.hasClass('is-open')
        if $root.hasClass('is-open-all')
          allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight + parentContentsHeight else parentContentsHeight
        else
          allContentsHeight = if parentContentsHeight isnt rootContentsHeight then rootContentsHeight - parentContentsHeight else parentContentsHeight

        $root.find('> .js-accordion__contents').removeAttr('style')
        $root.find('> .js-accordion__contents').css({
          'height': allContentsHeight
          'maxHeight': allContentsHeight
        })

    $parent.on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend',
      ()->
        if not $parent.hasClass('is-open')
          $parent.addClass('is-close')
    )
)

$('.js-tab-item').each(
  ()->
    $(this).find('a[href^="#"]').off('click.smoothScroll')
)

$url = new URL(window.location.href)
$param = $url.searchParams

$(window).on('load', ()->
  if $param.get('clinic')
    if $('.js-tab-item.' + $param.get('clinic')).length
      # console.log($('.js-tab-item.' + $param.get('clinic')).length)
      $('.js-tab-item.' + $param.get('clinic') + ' a[href^="#"]').trigger('click')
)

$('.js-tab-item a[href^="#"]').on('click',
  (e)->
    $parent = $(this).closest('.js-tab-box')
    e.preventDefault()
    $parent.find('.js-tab-item').removeClass('is-active')
    $(this).parent().addClass('is-active')
    $parent.find('.js-tab-box-contents').removeClass('is-active')
    $($(this).attr('href')).addClass('is-active')
)

$('.p-clinic__info__contents__details__clinics__item').on('click',
  (e)->
    $('.p-clinic__info__tab__item').removeClass('is-active')
    linkTab = $(this).attr('data-link')
    $('#' + linkTab).addClass('is-active')
)
